import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/Badge';
import PlayButton from 'components/Tile/components/PlayButton';
import NetworkImage from '../../../NetworkImage';

const DefaultOverlay = ({ badge, displayBrand, showPlayButton, theme }) => (
  <>
    <Badge badge={badge} theme={theme} />
    {showPlayButton && <PlayButton theme={theme} />}
    <div className={theme.networkImage}>
      <NetworkImage network={displayBrand} />
    </div>
  </>
);

export default DefaultOverlay;

DefaultOverlay.defaultProps = {
  badge: null,
  displayBrand: null,
  showPlayButton: false,
  theme: {},
};

DefaultOverlay.propTypes = {
  badge: PropTypes.string,
  displayBrand: PropTypes.string,
  showPlayButton: PropTypes.bool,
  theme: PropTypes.shape({}),
};
